/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DepositTypeDto
 */
export interface DepositTypeDto {
  /**
   *
   * @type {string}
   * @memberof DepositTypeDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DepositTypeDto
   */
  name: string;
}

export function DepositTypeDtoFromJSON(json: any): DepositTypeDto {
  return DepositTypeDtoFromJSONTyped(json, false);
}

export function DepositTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DepositTypeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function DepositTypeDtoToJSON(value?: DepositTypeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
